import { useTranslation } from 'react-i18next';
import { SupportedLanguages } from '../../types';
import { useSetLanguageToUrl } from '../useSetLanguageToUrl';

interface UseLanguageChangeOutput {
  handleChangeLanguage: (newLanguage: SupportedLanguages) => void;
  language: SupportedLanguages;
}

export const useLanguageChange = (): UseLanguageChangeOutput => {
  const {
    i18n: { changeLanguage, language }
  } = useTranslation();
  const navigateToLanguageUrl = useSetLanguageToUrl();

  const handleChangeLanguage = (newLanguage: SupportedLanguages): void => {
    if (newLanguage !== language) {
      changeLanguage(newLanguage)
        .then(() => {
          navigateToLanguageUrl(newLanguage);
        })
        .catch(() => changeLanguage(language));
    }
  };

  return {
    language: language as SupportedLanguages,
    handleChangeLanguage
  };
};
